import script from "./BlockDescriptionListPart.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlockDescriptionListPart.vue?vue&type=script&setup=true&lang=ts"

import "./BlockDescriptionListPart.vue?vue&type=style&index=0&id=9a2ca628&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a2ca628"]])

export default __exports__